import React from 'react';
import { Button, Col, Row, List, Spin, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import _ from 'lodash';



const ComponentQueue = ({ newComponents, savingChanges, onSubmitComponents, onRemoveComponent }) => {
	
    return (
		<>
			<Typography.Title level={4}>Components to Save</Typography.Title>
							
			<Row 
				gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
				flex="auto"
			>
				<List
					header={
						<Row
							gutter={{
								xs: 8,
								sm: 16,
								md: 24,
								lg: 32,
							}}
						>
							<Col span={8}>Item Code - Item Name</Col>
							<Col span={3}>Base Qty</Col>
							<Col span={3}>Planned Qty</Col>
							<Col span={4}>Stage</Col>
							<Col flex="auto">Reference Designator</Col>
						</Row>
					}
					itemLayout="horizontal"
					dataSource={newComponents}
					renderItem={(component, index) => (
						<List.Item 
							key={index}
							actions={[<Button type="link" key="list-remove-item" onClick={() => onRemoveComponent(index)}>remove</Button>]}
						>
							<Col span={8}>{ component.ItemCode } <strong>-</strong> { component.ItemName }</Col>
							<Col span={3}>{ component.BaseQty ? `${component.BaseQty}` : '' }</Col>
							<Col span={3}>{ component.PlannedQty ? `${component.PlannedQty} ` : ''}</Col>
							<Col span={4}>{ component.Stage ? `${component.Stage}` : '' }</Col>
							<Col flex="auto">{ component.ReferenceDesignator ? `${component.ReferenceDesignator}` : ''}</Col>
						</List.Item>
					)}
				/>
			</Row>
							
							
					<Button
						className="ts_portal_button ts_margin_top ts_button_primary"
						size="large"
						type="primary"
						disabled={newComponents.length === 0 || savingChanges }
						onClick={() => {
							onSubmitComponents()
						}}
					>
							SUBMIT TO SAP { savingChanges ? <Spin className="ts_margin_right" /> : <CheckOutlined style={{ fontSize: '18px', fontWeight: 'bolder'}} /> }
					</Button>
		</>
                
    );
};

export default ComponentQueue;
